import React from 'react';
interface PaxStatementHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    uen: string;
  };
  statement: {
    number: string;
    printedOn: string;
    printedBy: string;
    bookingReference: string;
    salesOwner: string;
    bookingStatus: 'Deposit Paid' | 'Confirmed' | 'Cancelled';
  };
}
export function PaxStatementHeader({
  company,
  statement
}: PaxStatementHeaderProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Confirmed':
        return 'bg-green-50 text-green-700 border-green-200';
      case 'Deposit Paid':
        return 'bg-yellow-50 text-yellow-700 border-yellow-200';
      case 'Cancelled':
        return 'bg-red-50 text-red-700 border-red-200';
      default:
        return 'bg-neutral-50 text-neutral-700 border-neutral-200';
    }
  };
  return <>
      {/* Top Header */}
      <div className="flex justify-between items-start mb-8" data-id="element-728">
        {/* Left: Company Info */}
        <div className="flex-1" data-id="element-729">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-4 flex items-center justify-center shadow-md" data-id="element-730">
            <span className="text-white font-bold text-xl" data-id="element-731">MT</span>
          </div>
          <h1 className="text-xl font-bold text-neutral-900 mb-2" data-id="element-732">
            {company.name}
          </h1>
          <div className="text-xs text-neutral-600 space-y-0.5 leading-relaxed" data-id="element-733">
            {company.address.map((line, i) => <p key={i} data-id="element-734">{line}</p>)}
            <p className="mt-2" data-id="element-735">Tel: {company.phone}</p>
            <p data-id="element-736">UEN: {company.uen}</p>
          </div>
        </div>

        {/* Right: Statement Metadata Box */}
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-737">
          <div className="space-y-2" data-id="element-738">
            <div className="flex justify-between" data-id="element-739">
              <span className="text-xs font-medium text-neutral-600" data-id="element-740">
                Pax Statement No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-741">
                {statement.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-742">
              <span className="text-xs font-medium text-neutral-600" data-id="element-743">
                Printed On:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-744">
                {statement.printedOn}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-745">
              <span className="text-xs font-medium text-neutral-600" data-id="element-746">
                Printed By:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-747">
                {statement.printedBy}
              </span>
            </div>
            <div className="h-px bg-neutral-200 my-2" data-id="element-748" />
            <div className="flex justify-between" data-id="element-749">
              <span className="text-xs font-medium text-neutral-600" data-id="element-750">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-751">
                {statement.bookingReference}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-752">
              <span className="text-xs font-medium text-neutral-600" data-id="element-753">
                Sales Owner:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-754">
                {statement.salesOwner}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <div className="text-center mb-4" data-id="element-755">
        <h2 className="text-2xl font-bold text-neutral-900 tracking-tight mb-3" data-id="element-756">
          PAX STATEMENT
        </h2>
        <div className="flex items-center justify-center gap-4" data-id="element-757">
          <span className={`text-xs font-semibold px-3 py-1.5 rounded-full border ${getStatusColor(statement.bookingStatus)}`} data-id="element-758">
            {statement.bookingStatus}
          </span>
        </div>
      </div>
    </>;
}